import {Register} from "../../genes/Register"
import {StringTools} from "../../StringTools"
import {HxOverrides} from "../../HxOverrides"

export const Path_Impl_ = Register.global("$hxClasses")["tink.url._Path.Path_Impl_"] = 
class Path_Impl_ {
	static parts(this1) {
		let _g = [];
		let _g1 = 0;
		let _g2 = this1.split("/");
		while (_g1 < _g2.length) {
			let p = _g2[_g1];
			++_g1;
			if (p != "") {
				let this1 = p;
				_g.push(this1);
			};
		};
		return _g;
	}
	static join(this1, that) {
		if (that == "") {
			return this1;
		} else if (that.charAt(0) == "/") {
			return that;
		} else if (this1.charAt(this1.length - 1) == "/") {
			return Path_Impl_.ofString(this1 + that);
		} else {
			let _g = this1.lastIndexOf("/");
			if (_g == -1) {
				return that;
			} else {
				let v = _g;
				return Path_Impl_.ofString(HxOverrides.substr(this1, 0, v + 1) + ((that == null) ? "null" : that));
			};
		};
	}
	static ofString(s) {
		let this1 = Path_Impl_.normalize(s);
		return this1;
	}
	static normalize(s) {
		s = StringTools.trim(StringTools.replace(s, "\\", "/"));
		if (s == ".") {
			return "./";
		};
		let isDir = StringTools.endsWith(s, "/..") || StringTools.endsWith(s, "/") || StringTools.endsWith(s, "/.");
		let parts = [];
		let isAbsolute = StringTools.startsWith(s, "/");
		let up = 0;
		let _g = 0;
		let _g1 = s.split("/");
		while (_g < _g1.length) {
			let part = _g1[_g];
			++_g;
			let _g2 = StringTools.trim(part);
			switch (_g2) {
				case "":
					break
				case ".":
					break
				case "..":
					if (parts.pop() == null) {
						++up;
					};
					break
				default:
				let v = _g2;
				parts.push(v);
				
			};
		};
		if (isAbsolute) {
			parts.unshift("");
		} else {
			let _g = 0;
			let _g1 = up;
			while (_g < _g1) {
				let i = _g++;
				parts.unshift("..");
			};
		};
		if (isDir) {
			parts.push("");
		};
		return parts.join("/");
	}
	static get __name__() {
		return "tink.url._Path.Path_Impl_"
	}
	get __class__() {
		return Path_Impl_
	}
}

